// extracted by mini-css-extract-plugin
export default {"modal-content":"deleteModalContent_modal-content__4JVnc","delete-icon":"deleteModalContent_delete-icon__TA5HA","primary":"deleteModalContent_primary__FBdXT"};